<template>
  <div class="main-menu">
    <ul>
      <li class="menu-item">
        <router-link :to="`/${$route.params.lang}`"  v-html="$t('text001')" class="menu-item-link" />
      </li>
      <li class="menu-item">
        <router-link :to="`/${$route.params.lang}/about`"  v-html="$t('text002')" class="menu-item-link" />
      </li>
      <li class="menu-item" v-if="termType === 3">
        <router-link :to="`/${$route.params.lang}/results`"  v-html="$t('text003')" class="menu-item-link" />
      </li>
      <li class="menu-item">
        <span  v-html="$t('text004')" class="menu-item-link" />
      </li>
      <li class="menu-item">
        <span v-html="$t('text005')" class="menu-item-link" />
      </li>
      <li class="menu-item">
        <span  v-html="$t('text006')" class="menu-item-link"/>
      </li>
      <li class="menu-item">
        <a @click.prevent="showAbout"  v-html="$t('text007')" class="menu-item-link"/>
      </li>
      <li class="menu-item">
        <a href="https://fire-emblem-heroes.com/" target="_blank" v-html="$t('text009')" class="menu-item-link" @click="sendGaEvent()" />
      </li>
      <li class="menu-item -form">
        <span class="label" v-html="$t('text008')" />:
        <language-select class="form" />
      </li>
    </ul>
    <app-download class="app-download"/>
    <sns-account class="sns-account" />
    <trademark />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ModelModal from '@models/modal'
import AppDownload from '@components/global/app-download.vue'
import SnsAccount from '@components/global/sns-account.vue'
import Trademark from '@components/global/trademark.vue'
import LanguageSelect from '@components/global/language-select.vue'
import modalNALinkForMypage from '@components/modals/modal-na-link-for-mypage'
import localeMenu from '@locales/menu'

export default {
  name: 'mainMenu',
  $messages: localeMenu,
  components: {
    AppDownload,
    SnsAccount,
    Trademark,
    LanguageSelect,
  },
  computed: {
    ...mapGetters('login', ['isLogin']),
    ...mapGetters('menu', ['termType']),
  },
  methods: {
    ...mapActions('terms', ['showTerms']),
    ...mapActions('modal', ['showModal']),
    showAbout() {
      this.showTerms()
    },
    goToMypage() {
      if(this.isLogin) {
        this.$router.push(`/${this.$route.params.lang}/mypage`)
        window.scrollTo(0, 0)
      } else {
        this.showModal(new ModelModal({ component: modalNALinkForMypage }))
      }
    },
    sendGaEvent(){
      this.$ga.event({
        eventCategory: 'click',
        eventAction: 'link_fehofficialsite',
        eventLabel: 'ellection',
        eventValue: true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.main-menu {
  background-image: url(#{$img-path}the-menu/bg_menu.png);
  padding-bottom: 30px;
  .menu-item {
    background-image: url(#{$img-path}the-menu/bg_line.png);
    background-position: 0 0;
    background-size: 640px 12px;
    background-repeat: no-repeat;
    color: #000;
    font-size: $fs-base * 1.4;
    font-weight: 600;
    &:last-child {
      background-image: url(#{$img-path}the-menu/bg_line.png), url(#{$img-path}the-menu/bg_line.png);
      background-size: 640px 12px,  640px 12px;
      background-position: 0 0, 0 100%;
      background-repeat: no-repeat, no-repeat;
    }
    .menu-item-link {
      display: flex;
      align-items: center;
      padding: 30px 20px 18px;
      &::before {
        content: "";
        width: 40px;
        height: 29px;
        display: inline-block;
        background-image: url(#{$img-path}the-menu/icon_arrow.png);
        margin-right: 6px;
      }
    }
    a.menu-item-link {
      @include tap-event();
      color: #000;
    }
    span.menu-item-link {
      opacity: .4;
      pointer-events: none;
    }
    &.-form {
      padding: 30px 20px;
      height: auto;
      > .form {
        display: inline-block;
        width: 452px;
      }
    }
  }
  > .app-download {
    margin-top: 40px;
  }
  > .sns-account {
    margin-top: 30px;
  }
  > .trademark {
    color: #000;
  }
}
</style>
